import { BaseCell } from 'src/components/TableV2/cells';
import { TableCellDiv } from 'src/core/ui/TableCellDiv';
import { formatCurrency } from 'src/utils/numberFormatter';

interface BuyerCreditCellProps {
  balance: number | null;
  currencyCode: string | null;
}

export function BuyerCreditCell({
  balance,
  currencyCode,
}: BuyerCreditCellProps) {
  if (balance == null || !currencyCode) {
    return <BaseCell />;
  }

  return (
    <TableCellDiv align="left">
      {formatCurrency(balance, currencyCode, 2)}
    </TableCellDiv>
  );
}
